import { getBuyOverlay } from './BuyOverlay'

class TitleBuyButtons {
    constructor(titleDetailComponentElement) {
        /* HTML Elements */
        this.buyButtonElements = titleDetailComponentElement.querySelectorAll('.buy-overlay-button, .sticky-buy-button')
        this.buyOverlaySourceElement = titleDetailComponentElement.querySelector('.buy-overlay-source')

        /* Components */
        this.buyOverlay = getBuyOverlay(titleDetailComponentElement)

        /* Properties */
        this.selectedVariationIndex = this.buyOverlaySourceElement
            ? Number(this.buyOverlaySourceElement.dataset.currentVariationIndex)
            : null
    }

    init() {
        if (!this.buyOverlay) {
            return
        }

        this.buyButtonElements.forEach((buyButtonElement) => {
            buyButtonElement.addEventListener('click', (event) => this.handleBuyButtonClickEvent(event))
        })

        this.openBuyOverlayFromUrl()
    }

    handleBuyButtonClickEvent(event) {
        if (event.currentTarget.classList.contains('add-cart-button')) {
            return
        }

        event.preventDefault()
        this.buyOverlay.open(this.getVariationIndex(event.currentTarget))
    }

    getVariationIndex(buyButtonElement) {
        if (buyButtonElement.dataset.variationIndex != null) {
            return Number(buyButtonElement.dataset.variationIndex)
        }

        let stickyBuyBarElement = buyButtonElement.closest('.sticky-buy-bar')

        return stickyBuyBarElement
            ? Number(stickyBuyBarElement.dataset.currentVariationIndex)
            : this.selectedVariationIndex
    }

    openBuyOverlayFromUrl() {
        let selectedPanelElement = this.buyOverlay.getSourcePanelElement(this.selectedVariationIndex)

        if (
            document.location.search.substr(1).indexOf('b=true') >= 0
            && selectedPanelElement
        ) {
            this.buyOverlay.open(this.selectedVariationIndex)
        }
    }
}

export default function init() {
    const titleDetailComponentElements = document.querySelectorAll('.title-detail-v2-component')

    titleDetailComponentElements.forEach(titleDetailComponentElement => {
        const titleBuyButtons = new TitleBuyButtons(titleDetailComponentElement)
        titleBuyButtons.init()
    })
}
